module.exports = "https://www.gc-pro.gnp.com.mx/cc3b301e3b20221abe3e6f1b6af66c57.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/videos/consultar-polizas/1.png
// module id = 1017
// module chunks = 0 1